import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as AuthStore from '../../app/store/AuthStore';
import Auth from '../../youwell-common/Auth';

class LoadProfileData extends React.Component {
    componentDidMount() {
        if (Auth.isUserAuthenticated() && !this.props.profileData) {
            this.props.getUserProfile();
        }
    }

    render() {
        return null;
    }
}

LoadProfileData.propTypes = {
    getUserProfile: PropTypes.func.isRequired,
    profileData: PropTypes.object,
};

LoadProfileData.defaultProps = {
    profileData: null,
};

const mapStateToProps = state => ({
    profileData: state.auth.profileData,
});

const mapDispatchToProps = dispatch => ({
    getUserProfile: bindActionCreators(AuthStore.actionCreators, dispatch).getUserProfile,
});

export default connect(mapStateToProps, mapDispatchToProps)(LoadProfileData);
